@import 'apps/webcomponents/src/assets/fonts.scss';

.title-container {
  height: calc(4 * var(--spacer));
  margin-bottom: calc(2 * var(--spacer));
}

.field-container {
  height: calc(4 * var(--spacer));
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

.action-buttons {
  padding: calc(1.5 * var(--spacer)) calc(5 * var(--spacer));
  display: flex;
  justify-content: space-between;
  background-color: var(--white-layout-300-primary);
  border-top: 1px solid var(--chart-050-hover);
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.container {
  flex-grow: 2;
  display: flex;
  height: 100%;
  flex-direction: column;
}

.table {
  flex-grow: 2;
  margin-bottom: -2px;
}
